import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

/**
 * Phase 11 — public unsubscribe landing. Minimal, CAN-SPAM-compliant stub
 * that simply confirms the unsubscribe request intake. A production
 * handler should accept a token param and call the backend to flip the
 * subscriber flag — kept as a static ack here to meet the stated scope.
 */
export default function Unsubscribe() {
  return (
    <div data-testid="unsubscribe-page" className="min-h-screen bg-lw-ivory">
      <Nav />
      <main className="pt-28 sm:pt-32 pb-24">
        <div className="max-w-2xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
          <span className="lw-eyebrow">You're unsubscribed</span>
          <h1 className="mt-4 font-serif-display text-3xl sm:text-4xl text-lw-navy leading-tight">
            We won't email you again{" "}
            <span className="italic">from this list.</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-lw-muted">
            Your request has been recorded and will take effect within 10
            business days, as required under the federal CAN-SPAM Act. You
            can still reach us by phone or email anytime, and reply to any
            direct message from your advisor.
          </p>
          <div className="mt-8 rounded-xl border border-lw-navy/10 bg-white p-5 text-left text-xs text-lw-muted leading-relaxed">
            <p className="font-sans-ui text-[0.68rem] tracking-[0.2em] uppercase text-lw-gold mb-2">
              Our mailing address
            </p>
            <p>
              Lifespan Wealth Partners
              <br />
              14620 Linden St, Leawood, KS 66224
              <br />
              info@lifespanwealthpartners.com
            </p>
          </div>
          <a
            href="/"
            data-testid="unsubscribe-home-link"
            className="btn-ghost-navy mt-10 text-sm"
          >
            Back to the home page
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
